import * as Sentry from "@sentry/vue";
import { getCookieValue, getQueryValue } from '@lib/utils.js';

const DSNConfig = 'https://e62ff788b1f843c9abdc9568fdb943dd@sentry.kuaishou.com/160';
const Log = {};

/**
 * 写普通日志
 * @param {String} title 
 * @param {String} context 
 * @param {String} level 
 * @param {Object} tags 
 */
Log.writeNormalLog = (title = '', context = '', level = 'info', tags = {}) => {
    Sentry.captureMessage(title, {
        level,
        tags,
        extra: {
            context
        }
    });
};

/**
 * 写异常日志
 * @param {String} title 
 * @param {String} context 
 * @param {String} level 
 * @param {Object} tags 
 */
Log.writeExLog = function (ex, context = '', level = 'error', tags = {}) {
    Sentry.captureException(ex, {
        level,
        tags,
        extra: {
            context
        }
    });
};

Log.Level = {
    INFO: 'info',
    WARNING: 'warning',
    ERROR: 'error'
};

export default {
    install(app, options = {}) {
        if (process.env.NODE_ENV === 'production') {
            const { globalTags = {} } = options;

            Sentry.init({
                app,
                dsn: DSNConfig,
                release: 'front-end-mulight-new',
                trackComponents: true,
            });

            app.config.errorHandler = (err) => {
                Log.writeExLog(err);
                app.config.globalProperties.$weblog.getOriginWeblog().plugins.radar.captureException(err);
            };

            Object.defineProperties(app.config.globalProperties, {
                $log: {
                    value: Log,
                    writable: true
                }
            });
        }
    }
};